"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HelpHint = _interopRequireDefault(require("../tooltips/HelpHint"));

/**
 * @class Disabled
 * @desc disables child content.
 *
 * @param {string} [data-id]
 *      To define the base "data-id" value for the top-level HTML container.
 * @param {string} [hintText]
 *     Text for the help hint will be rendered when the same button has a the prop disabled set to true.
 * @param {string} [disabledText]
 *     Text for the help hint will be rendered when the same button has a the prop disabled set to true.
 *     This will be deprecated soon. Use hintText instead.
 * @param {HelpHint.Placements} [placement]
 *     How to place the help hint.
 *
 * @example
 *  <Disabled>
 *      this is some text
 *  </Disabled>
 *
 */
var Disabled = function Disabled(_ref) {
  var children = _ref.children,
      dataId = _ref["data-id"],
      hintText = _ref.hintText,
      disabledText = _ref.disabledText,
      placement = _ref.placement;

  /* istanbul ignore if  */
  if (hintText || disabledText) {
    return /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
      "data-id": "help-hint-disabled",
      hintText: hintText || disabledText,
      placement: placement
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-id": dataId,
      className: "disabled-wrapper"
    }, children));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-id": dataId,
      className: "disabled-wrapper"
    }, children);
  }
};

Disabled.propTypes = {
  "data-id": _propTypes.default.string,
  hintText: _propTypes.default.string,
  disabledText: _propTypes.default.string,
  placement: _propTypes.default.string
};
var _default = Disabled;
exports.default = _default;
module.exports = exports["default"];